import React, { useEffect, useState } from 'react';
import {connect, dispatch} from 'react-redux'

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios, {source} from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'
import {authHeaders} from '../../../helpers'

import Chart from './Chart';
import { CircularProgress, Backdrop, Card, CardHeader, Divider } from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const AdditionsByDay = props => {
  const { account } = props;
  const classes = useClasses(styles);

  const [loading, setLoading] = useState(true)
  const [data, setData] = useState({
    labels: [],
    daily_added_merchants: [],
    daily_added_notes: [],
    hits: []
  })
  
  useEffect(() => {
    setLoading(true)
    let url = `/widgets/additions_by_day?days=30`
    if (account){
      url = `/widgets/additions_by_day?days=30&account_id=${account}`
    }
    let config = authHeaders()
    axios.get(url, config)
    .then(response => {
      if (response){
        const labels = []
        const daily_added_merchants = []
        const daily_added_notes = []
        const hits = []
        for(let key in response.data.data.daily_additions){
          labels.push(response.data.data.daily_additions[key].daily_addition_date)
          daily_added_merchants.push(response.data.data.daily_additions[key].total_merchants)
          daily_added_notes.push(response.data.data.daily_additions[key].total_notes)
        }
        setLoading(false)
        setData({
          labels: labels,
          daily_added_merchants: daily_added_merchants,
          daily_added_notes: daily_added_notes,
          hits: hits
        })
      }
      else {
        setLoading(false)
      }
    })
    .catch(error => {
      setLoading(false)
    })
    
    return () => {
      source.cancel()
    }
  }, [])

  let chart = (
    <CircularProgress color="inherit" />
  )
  if(!loading){
    chart = (
      <Chart
        data={data}
      />
    )
  }
  
  return (
    <Card>
      <CardHeader
        title={`Contributions By Day (Last 30 days)`}
      />
      <Divider />
      {chart}
    </Card>
  );
};

export default withErrorHandler(AdditionsByDay, axios)